/**
 * @generated SignedSource<<5bd075f46725098e024c99e192f629a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useImageUploaderMutation$variables = {
  filename?: string | null;
  filesize: number;
  filetype: string;
  metadata?: any | null;
  timestamp: number;
  type: string;
};
export type useImageUploaderMutation$data = {
  readonly getUploadUrl: {
    readonly presignedUrl: string | null;
    readonly storageObject: {
      readonly createdOn: any | null;
      readonly downloadUrl: string | null;
      readonly filename: string | null;
      readonly id: string;
      readonly key: any;
      readonly metaData: any | null;
      readonly thumbnailUrl: string | null;
    } | null;
  } | null;
};
export type useImageUploaderMutation = {
  response: useImageUploaderMutation$data;
  variables: useImageUploaderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filename"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filesize"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filetype"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timestamp"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "filename",
            "variableName": "filename"
          },
          {
            "kind": "Variable",
            "name": "filesize",
            "variableName": "filesize"
          },
          {
            "kind": "Variable",
            "name": "filetype",
            "variableName": "filetype"
          },
          {
            "kind": "Variable",
            "name": "metadata",
            "variableName": "metadata"
          },
          {
            "kind": "Variable",
            "name": "timestamp",
            "variableName": "timestamp"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "GetUploadURLPayload",
    "kind": "LinkedField",
    "name": "getUploadUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "presignedUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StorageObjectNode",
        "kind": "LinkedField",
        "name": "storageObject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downloadUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbnailUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaData",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useImageUploaderMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useImageUploaderMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "59ea1cdd47af6c379af841ba30ebc877",
    "id": null,
    "metadata": {},
    "name": "useImageUploaderMutation",
    "operationKind": "mutation",
    "text": "mutation useImageUploaderMutation(\n  $timestamp: Float!\n  $filetype: String!\n  $type: String!\n  $filesize: Float!\n  $filename: String\n  $metadata: JSONString\n) {\n  getUploadUrl(input: {timestamp: $timestamp, filetype: $filetype, type: $type, filesize: $filesize, filename: $filename, metadata: $metadata}) {\n    presignedUrl\n    storageObject {\n      id\n      key\n      filename\n      createdOn\n      downloadUrl\n      thumbnailUrl\n      metaData\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4975fe08efb1f7bc3b74dfb0b80c71d2";

export default node;
